import axios, { AxiosResponse } from 'axios';

export interface ICmsApi {
  getDocCMS(docType: string): Promise<AxiosResponse<any>>;
}

export class CmsApi implements ICmsApi {
  async getDocCMS(docType: string, generic = false): Promise<AxiosResponse<any>> {
    return axios.get('api/cms/documents/search', { params: { docType, generic } });
  }
  async getDocCMSContractDocument(defaultValue: boolean, documentName :string): Promise<AxiosResponse<any>> {
    return axios.get('api/cms/documents/searchContractDocumment', { params: { defaultValue, documentName } });
  }
}
